import type { AssetDto } from "@core/typesV2";

export function isAssetSubmittable(asset: AssetDto) {
  return "point" in asset.settings;
}
